export default __webpack_public_path__ + "static/media/sr-pago-main-logo.5f286634.svg";